import * as zod from 'zod';

export const ModbusTCPServerState = zod.object({
  kind: zod.literal('ModbusTCPServer'),
});

export type ModbusTCPServerState = zod.infer<typeof ModbusTCPServerState>;
